import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import facade from '../assets/images/castellanza/facciata.webp';
import guitars from '../assets/images/castellanza/chitarre.webp';
import room from '../assets/images/castellanza/sala.webp';
import sax from '../assets/images/castellanza/sassofono.webp';
import vinyl from '../assets/images/castellanza/vinili.webp';
import freddie from '../assets/images/castellanza/freddie.webp';
import bar from '../assets/images/castellanza/bancone.webp';
import mural from '../assets/images/castellanza/murale.webp';
import signature from '../assets/images/firma-gold-raziel.png';
import robocop from '../assets/images/robocop-about.webp';
import hologram from '../assets/images/hologram-about.webp';
import './About.css';

const archive = { facade, guitars, room, sax, vinyl, freddie, bar, mural };

function Photo({ name, eager = false }) {
  const { t } = useTranslation();
  return (
    <figure className={`sr-about-photo sr-about-photo--${name}`}>
      <img src={archive[name]} alt="" loading={eager ? 'eager' : 'lazy'} />
      <figcaption>{t(`about_story.photos.${name}`)}</figcaption>
    </figure>
  );
}

function Concept({ name, src, description }) {
  const { t } = useTranslation();
  const frame = useRef(null);
  useEffect(() => {
    const image = frame.current;
    if (!window.IntersectionObserver) return;
    image.classList.add('is-waiting');
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        image.classList.remove('is-waiting');
        observer.disconnect();
      }
    }, { threshold: 0.18 });
    observer.observe(image);
    return () => {
      observer.disconnect();
      image.classList.remove('is-waiting');
    };
  }, []);

  return (
    <aside className={`sr-concept sr-concept--${name}`}>
      <div className="sr-concept-copy">
        <p className="sr-about-label">{t('about_story.renderLabel')}</p>
        <h3>{t(`about_story.${name}Title`)}</h3>
        <p>{t(`about_story.${description}`)}</p>
      </div>
      <div className="sr-concept-frame" ref={frame}>
        <img src={src} width="1280" height="854" loading="lazy" alt={t(`about_story.${name}Alt`)} />
      </div>
    </aside>
  );
}

export default function About() {
  const { t } = useTranslation();
  return (
    <main className="sr-about">
      <header className="sr-about-opening">
        <div>
          <p className="sr-about-label">{t('about_title')}</p>
          <h1>{t('about_story.title')}</h1>
          <p className="sr-about-lead">{t('about_story.lead')}</p>
        </div>
        <Photo name="facade" eager />
      </header>

      <section className="sr-about-chapter">
        <p className="sr-about-label">{t('about_story.founderLabel')}</p>
        <h2>{t('about_story.founderTitle')}</h2>
        <p>{t('about_story.founder')}</p>
        <p>{t('about_story.experience')}</p>
        <img className="sr-about-signature" src={signature} alt="Gold Raziel" />
        <div className="sr-about-triptych">
          <Photo name="room" />
          <Photo name="sax" />
          <Photo name="vinyl" />
        </div>
      </section>

      <section className="sr-about-chapter">
        <p className="sr-about-label">{t('about_story.tableLabel')}</p>
        <h2>{t('about_story.tableTitle')}</h2>
        <p>{t('about_story.table')}</p>
        <div className="sr-about-pair">
          <Photo name="guitars" />
          <Photo name="bar" />
        </div>
        <Concept name="robocop" src={robocop} description="replicas" />
      </section>

      <section className="sr-about-chapter">
        <p className="sr-about-label">{t('about_story.stageLabel')}</p>
        <h2>{t('about_story.stageTitle')}</h2>
        <p>{t('about_story.stage')}</p>
        <div className="sr-about-duo">
          <Photo name="freddie" />
          <Photo name="mural" />
        </div>
        <Concept name="hologram" src={hologram} description="holography" />
        <p>{t('about_story.future')}</p>
      </section>
    </main>
  );
}
